import React from 'react';
import './style.scss';

export interface UQInputProps {
  label?: string;
  name: string;
  type?: 'text' | 'email' | 'password' | 'number';
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
  boldLabel?: boolean; 
  clearable?: boolean; 
}

const UQInput: React.FC<UQInputProps> = ({
  label,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  required = false,
  boldLabel = false, 
  clearable = false, 
}) => {
  const handleClear = () => {
    if (onChange) {
      onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <div className="uq-input">
      {label && (
        <label
          htmlFor={name}
          className={`uq-input-label ${boldLabel ? 'bold' : ''}`}
        >
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className="uq-input-wrapper">
        <input
          id={name}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={`uq-input-field ${error ? 'uq-input-error' : ''}`}
        />
        {clearable && value && (
          <button
            type="button"
            className="uq-input-clear"
            onClick={handleClear}
            aria-label="Clear input"
          >
            ✕
          </button>
        )}
      </div>
      {error && <p className="uq-input-error-message">{error}</p>}
    </div>
  );
};

export default UQInput;